module.exports = __webpack_public_path__ + "static/media/0007.5a720df.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/0007.mp3
// module id = JQWw
// module chunks = 0